import { render, staticRenderFns } from "./CrudDataTableHeader.vue?vue&type=template&id=1f5c8c2e&lang=pug&"
import script from "./CrudDataTableHeader.vue?vue&type=script&lang=js&"
export * from "./CrudDataTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./CrudDataTableHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrudDataTableHeader.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VCheckbox,
  VIcon,
})
